import type { ThemeConfig } from 'antd';

// Тема Ant Design, поднятая из design/assets/tokens.css.
// Маппим только те токены, для которых есть прямой эквивалент в AntD;
// остальное оставляем на дефолте, чтобы не делать неверного override.
export const slTheme: ThemeConfig = {
  token: {
    // Цвета
    colorPrimary: '#2dbdb8', // --health-turquoise (accent)
    colorSuccess: '#2dbdb8', // здоровый бирюзовый = успех в DS
    colorWarning: '#e0a23a',
    colorError: '#d8556b',
    colorInfo: '#2a5780',
    colorLink: '#1fa9a4',
    colorLinkHover: '#0e3559',

    // Текст и фон
    colorTextBase: '#0e3559',
    colorBgBase: '#ffffff',
    colorBgLayout: '#f5f8fb', // --mist
    colorBorder: '#e3eaf0', // --hairline
    colorBorderSecondary: '#eef2f6',

    // Типографика
    fontFamily:
      "'Manrope', 'PT Root UI', 'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontFamilyCode: "'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace",
    fontSize: 14,

    // Радиусы
    borderRadius: 12, // --radius-md
    borderRadiusSM: 8,
    borderRadiusLG: 16,

    // Контролы
    controlHeight: 36,
    wireframe: false,
  },
  components: {
    Button: {
      borderRadius: 999, // pill, как в дизайне SLButton
      borderRadiusLG: 999,
      borderRadiusSM: 999,
      controlHeight: 36,
      fontWeight: 600,
      primaryShadow: '0 0 0 6px rgba(45, 189, 184, 0.10)',
    },
    Layout: {
      headerBg: '#ffffff',
      headerHeight: 64,
      headerPadding: '0 24px',
      siderBg: '#0e3559',
      bodyBg: '#f5f8fb',
    },
    Menu: {
      darkItemBg: '#0e3559',
      darkSubMenuItemBg: '#0e3559',
      darkItemSelectedBg: 'rgba(45, 189, 184, 0.15)',
      darkItemSelectedColor: '#6fddd8',
    },
    Table: {
      headerBg: '#f5f8fb',
      headerColor: '#5a7388',
      rowHoverBg: '#f5f8fb',
    },
    Tag: {
      borderRadiusSM: 6,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Modal: {
      borderRadiusLG: 16,
    },
  },
};
